const FALLBACK_API_URL = 'http://localhost:3001/api/v2';
const environment = process.env.REACT_APP_API_URL || FALLBACK_API_URL;
export const apiUrl = environment;

export default environment;
